<template>
  <v-flex xs12>
    <v-layout row wrap>
      <v-flex xs12>
        <slot name="container_progress"></slot>
      </v-flex>

      <v-flex xs12>
        <slot name="container_header"></slot>
      </v-flex>

      <v-flex xs12>
        <slot name="container_content"></slot>
      </v-flex>

      <slot name="container_actions"></slot>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  mounted() {
    //console.log("foo", "AUDIT ITEM CONTAINER MOUNTED");
  }
};
</script>
